import {
  APP_SET_LOADING,
} from '../constants/action-types'

const initialState = {
  loading: false,
}

function app(state = initialState, action) {
  switch (action.type) {
    case APP_SET_LOADING:
      return { ...state, loading: action.payload }
    default:
      return state
  }
}

export default app